import * as React from 'react';
import '../../../../../types/product.js';
import { isSinglePurchase } from '../../../../../types/typeguards.js';
import { CartDiscountSelectorContainer } from '../../../components/CartDiscountSelector/CartDiscountSelectorContainer.js';
import '@grandvisionhq/lib-visuals';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/state';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '../../../../../hooks/useCartDiscountsQuery/types.js';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../operations/queries/get-manufacturer-by-key.js';
import '../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/inventory';
import '@grandvisionhq/iris-ui';
import '../../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { useCLEcommContext } from '../../context/CLEcommContext.js';

const CLCartDiscountSelector = ({ className  })=>{
    const { state , selectors , actions  } = useCLEcommContext();
    const enabledSelectedQuantity = selectors.getEnabledSelectedQuantity(state);
    const isSinglePurchaseType = isSinglePurchase(state.configurations.purchaseType);
    if (!isSinglePurchaseType) {
        return null;
    }
    const handleCartDiscountSelection = (discount, isSelected)=>{
        if (isSelected) {
            return;
        }
        actions.updateTotalQuantity(discount.minimumQuantity);
    };
    const handleCartDiscountReset = ()=>{
        actions.resetTotalQuantity();
    };
    return /*#__PURE__*/ React.createElement(CartDiscountSelectorContainer, {
        className: className,
        selectedQuantity: enabledSelectedQuantity || undefined,
        onCartDiscountSelection: handleCartDiscountSelection,
        onCartDiscountReset: handleCartDiscountReset
    });
};

export { CLCartDiscountSelector };
//# sourceMappingURL=CLCartDiscountSelector.js.map
